$('.slider').slick({
  arrows: true,
  infinite: false,
  speed: 100,
  touchThreshold: 100,
  swipeToSlide: true,
  waitForAnimate: false,
});

setTimeout(function(){
  equalheight('.cord-slider-content');
}, 200);

$(document).on('click','.core-class-right .right-slider-items a', function (e) {
  e.preventDefault();
  var tbid = $('#'+$(this).attr('data-tabin')).offset().top;
  var index = $(this).attr('data-tabin').replace('tab-','');
  $(this).closest('.class-right-slider').slick('slickGoTo', parseInt(index - 1));
  $('.tabs-nav.page_main_tab').find('.tab-link').removeClass('current');
  $('.tabs-nav.page_main_tab').find('.tab-link[data-tab="'+ $(this).attr('data-tabin') +'"]').addClass('current');
  $("html, body").animate({ scrollTop: tbid - 100 }, 1000);
});

$(document).on('click', ".cm-filter-by", function () {
  $(this).toggleClass('active')

  $('.filter-sortby').removeClass("active");
  $('.filter-search').removeClass("active");
  $('.collection-filter .compare-hats').removeClass('this_active');
  $('.compare-hat-option').removeClass("active");
  $(".compare-popup, body").removeClass("active-comp-popup");
  $(".all-filter").slideToggle();
  $(".cm-sort-filter").slideUp();
  $(".filter-search-drop").slideUp();
});

$(document).on("click",'.core-class-filter .filter-select li a', function (e) {
  e.preventDefault();
  var value = $(this).attr('data-tag');
  var pdcnt = 0
  $(".core_classic_wrapper .product-card").filter(function() {
    if($(this).find('.product_tags_hide').text().indexOf(value) > -1){
      pdcnt++;
    }
    $(this).toggle($(this).find('.product_tags_hide').text().indexOf(value) > -1);
  });
  if(pdcnt == 0){
    $('.core_class_collection .no_matches').show();
    $('.core_class_col-wrapper').addClass('no_match');
  }else{
    $('.core_class_collection .no_matches').hide();
    $('.core_class_col-wrapper').removeClass('no_match');
  }
  $('.core_classic_wrapper .cm-filter-main .filter-tag li span').text($(this).text());
  $('.core_classic_wrapper .cm-filter-main .filter-tag').show();
});
